var _title, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "95B4CAE2-2C52-4ECF-874C-756DA82A2204")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 592,
    height: 228,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-4.4%",
    y: "-9.6%",
    width: "108.8%",
    height: "122.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.603921569   0 0 0 0 0.650980392   0 0 0 0 0.698039216  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup",
    transform: "translate(-198.000000, -232.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 720,
    height: 576,
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    id: "email-copy-3",
    transform: "translate(64.000000, 238.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sales-rep-options",
    transform: "translate(64.000000, 210.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 16.000000)",
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(112.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FDA45C",
    opacity: 0.100000001,
    x: 0,
    y: 0,
    width: 66,
    height: 24,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FDA45C",
    cx: 6,
    cy: 6,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,9.33333333 C6,7.11111111 6,6 6,6 C6,6 7.11111111,6 9.33333333,6 C9.33333333,4.15905083 7.84094917,2.66666667 6,2.66666667 C4.15905083,2.66666667 2.66666667,4.15905083 2.66666667,6 C2.66666667,7.84094917 4.15905083,9.33333333 6,9.33333333 Z",
    id: "Oval",
    fill: "#FDA45C",
    transform: "translate(6.000000, 6.000000) scale(-1, -1) translate(-6.000000, -6.000000) "
  }))))))))));
};

export default __webpack_public_path__ + "static/media/partial.fe0aadc9.svg";
export { SvgComponent as ReactComponent };